import { jsx as _jsx } from "react/jsx-runtime";
import NativePortal from "../specs/OneNativePortalViewNativeComponent";
import NativePortalHost from "../specs/OneNativePortalHostViewNativeComponent";
function Portal(param) {
  var { hostName = "", name = "", ...props } = param;
  return /* @__PURE__ */ _jsx(NativePortal, {
    ...props,
    hostName,
    name
  });
}
function PortalHost(props) {
  return /* @__PURE__ */ _jsx(NativePortalHost, {
    ...props
  });
}
export {
  Portal,
  PortalHost
};
//# sourceMappingURL=Portal.native.js.map
